module.exports = {"id":"183937","name":"Gregory van der Wiel","rating":"75","photo":"./data/images/photos/2/183937.png","club":{"name":"Toronto FC","logo":"./data/images/clubs/TorontoFC.png"},"positions":["DD","DLD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GregoryvanderWiel0.json
// module id = 1641
// module chunks = 0